import APIRequestState from './_util/api-request';

class CreditState extends APIRequestState {
  get method() { return 'GET'; }
  get url() { return '/credit'; }
}

export default CreditState;



// WEBPACK FOOTER //
// ./spa/state/credit.jsx